export const defaultSelectedOptions = ['folder'];
